.uk {
  background-image: url('img/uk.svg') !important;
  width: 2.25rem;
}

.no {
  background-image: url('img/no.svg') !important;
  width: 1.7rem;
}

.flagWrapper {
  align-items: center;
  display: inline-flex;
  justify-content: center;

  .flag {
    background: center / contain no-repeat;
    height: 1.1rem;
    margin: 0.5rem 0;
    opacity: 0.5;

    &:hover,
    &:focus,
    &.highlighted {
      opacity: 1;
    }
  }
}
